import { DependencyList, useEffect } from "react";

export const pushToDataLayer = (
    eventName: string,
    payload: Record<string, any>
) => {
    pushToGoogleTagManager(eventName, payload);
};

export const pushToGoogleTagManager = (
    eventName: string,
    payload: Record<string, any>
) => {
    if (window) {
        (window as any).dataLayer.push({
            event: eventName,
            ...payload,
        });
    } else {
        console.error(
            new Error(
                `analytics: Can't log event "${eventName}" to gtm (no window)`
            )
        );
    }
};

const pushToAnalytics = pushToDataLayer;

export const usePushToDataLayer = (
    ...[eventName, payload, dependencies]:
        | Parameters<typeof pushToDataLayer>
        | [...Parameters<typeof pushToDataLayer>, DependencyList]
) =>
    useEffect(
        () => pushToDataLayer(eventName, payload),
        [eventName, payload, ...(dependencies ?? [])]
    );

export default pushToAnalytics;
